/**
 * Мини-санитайзер HTML для контента новостей (без зависимостей).
 * Контент пишут только админы, но прогонять его через whitelist всё равно нужно:
 * дешевле, чем потом ловить XSS через вставленный из буфера мусор.
 */

const ALLOWED_TAGS = new Set([
    'p', 'br', 'b', 'strong', 'i', 'em', 'u', 's', 'strike', 'del',
    'h1', 'h2', 'h3', 'h4', 'ul', 'ol', 'li', 'blockquote', 'hr',
    'span', 'div', 'a', 'img', 'figure', 'figcaption', 'code', 'pre',
    'table', 'thead', 'tbody', 'tr', 'td', 'th',
]);

const ALLOWED_ATTRS = {
    a: ['href', 'target', 'rel'],
    img: ['src', 'alt', 'width', 'height'],
    '*': ['style', 'class'],
};

const SAFE_STYLE = /^(color|background-color|font-size|font-weight|font-style|text-align|text-decoration|line-height)$/i;

const cleanStyle = (value = '') => value
    .split(';')
    .map(rule => rule.trim())
    .filter(Boolean)
    .filter(rule => {
        const [prop, val] = rule.split(':');
        if (!prop || !val) return false;
        if (!SAFE_STYLE.test(prop.trim())) return false;
        return !/url\s*\(|expression|javascript:/i.test(val);
    })
    .join('; ');

const isSafeUrl = (url = '') => {
    const value = url.trim().toLowerCase();
    if (value.startsWith('javascript:') || value.startsWith('data:text/html')) return false;
    return true;
};

export const sanitizeNewsHtml = (html = '') => {
    if (!html || typeof html !== 'string') return '';
    try {
        const doc = new DOMParser().parseFromString(`<div>${html}</div>`, 'text/html');
        const root = doc.body.firstChild;

        const walk = (node) => {
            [...node.childNodes].forEach((child) => {
                if (child.nodeType === 3) return;              // текст — ок
                if (child.nodeType !== 1) { child.remove(); return; }

                const tag = child.tagName.toLowerCase();
                if (!ALLOWED_TAGS.has(tag)) {
                    // тег не в whitelist — сохраняем текст, выкидываем обёртку
                    const text = doc.createTextNode(child.textContent || '');
                    child.replaceWith(text);
                    return;
                }

                const allowed = [...(ALLOWED_ATTRS[tag] || []), ...ALLOWED_ATTRS['*']];
                [...child.attributes].forEach((attr) => {
                    const name = attr.name.toLowerCase();
                    if (name.startsWith('on') || !allowed.includes(name)) {
                        child.removeAttribute(attr.name);
                        return;
                    }
                    if (name === 'style') {
                        const cleaned = cleanStyle(attr.value);
                        if (cleaned) child.setAttribute('style', cleaned);
                        else child.removeAttribute('style');
                    }
                    if ((name === 'href' || name === 'src') && !isSafeUrl(attr.value)) {
                        child.removeAttribute(attr.name);
                    }
                });

                if (tag === 'a') {
                    child.setAttribute('target', '_blank');
                    child.setAttribute('rel', 'noopener noreferrer');
                }

                walk(child);
            });
        };

        walk(root);
        return root.innerHTML;
    } catch (e) {
        console.warn('[sanitizeNewsHtml]', e);
        return '';
    }
};

/** Текст без разметки — для свёрнутого превью в формате «Фул картинка» */
export const stripHtml = (html = '') => {
    if (!html) return '';
    try {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return (doc.body.textContent || '').replace(/\s+/g, ' ').trim();
    } catch (e) {
        return '';
    }
};